<template>
  <div>
    <div v-if="error != null">
      <div class="row">
        <div class="col">
          <div class="alert alert-danger">{{ error }}</div>
        </div>
      </div>
    </div>
    <!--<div>
      <div class="row">
        <div class="col">
          <p>Sobald ein Autor gespeichert ist, können Sie weitere Institute hinzufügen.</p>
        </div>
      </div>
    </div-->
    <div v-if="importMode === null">
      <div class="row" v-if="importMode === null">
        <div class="col">
          <div class="card h-100">
            <div class="card-header bg-primary text-white">
              {{ wording[abstract.setting_submission_id].author_import.manuell }}
            </div>
            <div class="card-body">
              <p class="card-text">{{ wording[abstract.setting_submission_id].author_import.manuell_txt }}</p>
            </div>
            <div class="card-footer">
              <button class="btn btn-primary" v-on:click="manually()">{{ wording[abstract.setting_submission_id].author_import.btn_weiter }}</button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card h-100">
            <div class="card-header bg-primary text-white">
              {{ wording[abstract.setting_submission_id].author_import.suche }}
            </div>
            <div class="card-body">
              <p class="card-text">{{ wording[abstract.setting_submission_id].author_import.suche_txt }}</p>
              <!--
              <div class="form-group">
                <label for="membernumber">Ihre Mitgliedsnummer:</label>
                <input type="text" class="form-control" aria-describedby="dguHelp" id="membernumber"
                       v-model="localmember">
                <small id="dguHelp" class="form-text text-muted">Der Import steht nur DGU Mitgliedern zur
                  Verfügung.</small>
              </div>
              <div class="row" v-if="validmember != null && !validmember">
                <div class="col">
                  <div class="alert alert-danger">Kein Import möglich!<br>Bitte geben Sie ihre gültige Mitgliedsnummer
                    an.
                  </div>
                </div>
              </div>
              -->
            </div>
            <div class="card-footer">
              <button class="btn btn-primary" v-on:click="checkMember()">{{ wording[abstract.setting_submission_id].author_import.btn_weiter }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-sm btn-danger" v-on:click="cancel">{{ wording[abstract.setting_submission_id].author_import.btn_abbruch }}</button>
        </div>
      </div>
    </div>
    <div v-else-if="importMode === 'search' && selected === null">
      <div class="row">
        <div class="col">
          <div class="row form-group">
            <div class="col">
              <label class="col-form-label font-weight-bold p-0">
                <span>{{ wording[abstract.setting_submission_id].author_import.vorname }}</span>
              </label>
              <input type="text" name="firstname" required="required" autocomplete="on" class="form-control"
                     v-model="searchfields.firstname" v-on:keydown.enter="search()">
            </div>
            <div class="col">
              <label class="col-form-label font-weight-bold p-0">
                <span>{{ wording[abstract.setting_submission_id].author_import.nachname }}</span>
              </label>
              <input type="text" name="lastname" required="required" autocomplete="on" class="form-control"
                     v-model="searchfields.lastname" v-on:keydown.enter="search()">
            </div>
          </div>
          <div class="row form-group mt-3 mb-3">
            <div class="col">
              <div class="">
                <label class="col-form-label font-weight-bold p-0">
                  <span>{{ wording[abstract.setting_submission_id].author_import.ort }}</span>
                </label>
                <input type="text" name="city" autocomplete="on" class="form-control" v-model="searchfields.city"
                       v-on:keydown.enter="search()">
              </div>
            </div>
          </div>
          <!--          <div class="row form-group mt-3 mb-3">-->
          <!--            <div class="col">-->
          <!--              <div class="">-->
          <!--                <label class="col-form-label font-weight-bold p-0">-->
          <!--                  <span>Land</span>-->
          <!--                </label>-->
          <!--                <treeselect-->
          <!--                    class="w-auto"-->
          <!--                    value-consists-of="BRANCH_PRIORITY"-->
          <!--                    v-model="searchfields.country" :options="this.countryData()"></treeselect>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="row">
            <div class="col d-flex">
              <Button class="btn btn-sm btn-success ml-auto" :disabled="processing === true" v-on:click="search()">
                {{ wording[abstract.setting_submission_id].author_import.btn_suche }}
              </Button>
            </div>
          </div>
        </div>
        <div class="col border-left" v-if="results != null && !processing">
          <div>
            <div class="font-weight-bold p-0">{{ wording[abstract.setting_submission_id].author_import.suchergebnis }}</div>
            <small class="text-muted">{{ wording[abstract.setting_submission_id].author_import.suchergebnis_txt }}</small>
          </div>
          <Button class="btn btn-sm btn-primary mt-1" v-on:click="manually()">{{ wording[abstract.setting_submission_id].author_import.btn_haendisch_eingeben }}</Button>
          <div class="list-group mt-3 overflow-auto">
            <button type="button" class="list-group-item list-group-item-action" v-for="result in results"
                    v-bind:key="result.id" v-on:click="selectNewAuthor(result)">
              <div>
                <span v-if="result.lastname">{{ result.lastname }},&nbsp;</span>
                <span v-if="result.firstname">{{ result.firstname }}</span>
              </div>
              <div class="smaller">
                <div v-if="result.institute && result.institute.trim().length > 1">Institut: {{
                    result.institute
                  }}
                </div>
                <div v-if="result.department && result.department.trim().length > 1">
                  Abteilung: {{ result.department }}
                </div>
                <div v-if="result.city">Stadt: {{ result.city }}</div>
              </div>
            </button>
          </div>
        </div>
        <div class="col border-left" v-else-if="processing === true">
          <loader></loader>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-sm btn-danger" v-on:click="cancel">{{ wording[abstract.setting_submission_id].author_import.btn_abbruch }}</button>
        </div>
      </div>
    </div>
    <div v-else-if="importMode === 'submitter' && processing === true">
      <loader></loader>
    </div>
    <div v-else-if="importAuthor">
      <AuthorForm @authorCreated="authorCreated"></AuthorForm>
      <div class="row mt-3">
        <div class="col">
          <button class="btn btn-sm btn-danger" v-on:click="cancel">{{ wording[abstract.setting_submission_id].author_import.btn_abbruch }}</button>
          <Button class="btn btn-sm btn-primary ml-3" v-on:click="manually()">{{ wording[abstract.setting_submission_id].author_import.btn_haendisch_eingeben }}</Button>
        </div>
      </div>
    </div>
    <div v-else-if="importInstitute">
      <Instituteform @instituteCreated="instituteCreated"></Instituteform>
    </div>
  </div>
</template>

<script>
import entitegenerator from "entite-generator";
import {mapActions, mapGetters, mapState, mapMutations} from "vuex";
import AuthorForm from "../author/AuthorForm";
import Instituteform from "../author/InstituteForm";
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    Instituteform,
    AuthorForm,
    entitegenerator,
    Treeselect
  },
  name: "AuthorSearch",
  data() {
    return {
      importMode: 'search', //null, search, submitter
      searchfields: {},
      results: null,
      error: null,
      selected: null,
      importAuthor: false,
      importInstitute: false,
      processing: false,
      localmember: null
    };
  },
  computed: {
    ...mapState(["mode", "user", 'wording', "language", 'abstract']),
    ...mapState('dgumember', ["selectedAuthor", "selectedInstitute", "membernumber", "validmember"])
  },
  mounted() {
    //@TODO: ÄNNDERN VOR COMMIT
    this.importMode = null;
  },
  methods: {
    ...mapActions('dgumember', ['GET_AUTHORS', 'GET_AUTHOR', 'VALID_MEMBER']),
    ...mapMutations('dgumember', ['SET_SELECTEDAUTHOR', 'SET_SELECTEDINSTITUTE']),
    ...mapMutations('dgumember', ['SET_VALID_MEMBER', 'SET_MEMBER_NUMBER']),
    /*
        async checkMember() {
      this.SET_VALID_MEMBER({'validMember': null});
      await this.VALID_MEMBER(this.localmember).then((result) => {
        this.SET_VALID_MEMBER({'validMember': true});
        this.SET_MEMBER_NUMBER({'membernumber': this.localmember})
        this.importMode = 'search';
      }).catch((error) => {
        this.localmember = null;
        this.SET_VALID_MEMBER({'validMember': false});
      });
    },
    */
    async checkMember() {
      this.importMode = 'search';
    },
    async search() {
      this.error = null;
      if (this.processing === true) {
        return;
      }
      if (!this.searchfields.firstname && !this.searchfields.lastname && !this.searchfields.city) {
        this.error = this.wording[2].author_import.insert_search;
        return;
      }
      this.processing = true;
      this.results = null;
      await this.GET_AUTHORS(this.searchfields).then((result) => {
        this.results = result.data;
      }).catch((error) => {
      });
      this.processing = false;
    },
    selectNewAuthor(data) {
      this.$set(this.mode, 'import', true);
      let mappedAuthor = {
        'external_id': data.id,
        'firstname': data.firstname.trim(),
        'lastname': data.lastname.trim(),
        /*'additional_content__dgu_mitglied': 'Ja',
        'additional_content__dgu_mitgliedsnummer': data.id,*/
        /*"additional_content__vortragsdauer": "12",
        "additional_content__diskussionsdauer": "3",*/
        'additional_content__data_import': true,
        'additional_content__data_edited': false,
      };
      if (data.mail) {
        mappedAuthor.email = data.mail.trim();
      }
      /*
      if (data.email_alternative) {
        mappedAuthor.email_alternative = data.email_alternative.trim();
      }
      if (data.phone) {
        mappedAuthor.phone = data.phone.trim();
      }
      if (data.mobile) {
        mappedAuthor.cellphone = data.mobile.trim();
      }*/
      console.log(data)
      if (data.foa) {
        switch (data.foa) {
          case 'Sehr geehrter Herr':
            mappedAuthor.salutation_id = 4;
            break;
          case 'Sehr geehrte Frau':
            mappedAuthor.salutation_id = 5;
            break;
          case 'Sehr geehrter Herr Dr.':
            mappedAuthor.salutation_id = 6;
            break;
          case 'Sehr geehrte Frau Dr.':
            mappedAuthor.salutation_id = 7;
            break;
          case 'Sehr geehrter Herr Priv.-Doz. Dr.':
            mappedAuthor.salutation_id = 8;
            break;
          case 'Sehr geehrte Frau Priv.-Doz. Dr.':
            mappedAuthor.salutation_id = 9;
            break;
          case 'Sehr geehrter Herr Professor':
            mappedAuthor.salutation_id = 10;
            break;
          case 'Sehr geehrte Frau Professor':
            mappedAuthor.salutation_id = 11;
            break;
        }
      }
      if (data.titel) {
        mappedAuthor.title = data.titel.trim();
      }
      console.log(mappedAuthor)
      this.SET_SELECTEDAUTHOR({'selectedAuthor': mappedAuthor});
      this.selectNewInsitute(data);
      this.selected = data;
      this.importAuthor = true;
      this.importInstitute = false;
    },
    selectNewInsitute(data) {
      this.$set(this.mode, 'import', true);
      let mappedInstitute = {};
      mappedInstitute.additional_content__data_import = true;
      mappedInstitute.additional_content__data_edited = false;
      if (data.institute) {
        mappedInstitute.name = data.institute.trim();
      }
      if (data.department) {
        mappedInstitute.department = data.department.trim();
      }
      /*if (data.street) {
        mappedInstitute.street = data.street.trim();
      }*/
      if (data.city) {
        mappedInstitute.city = data.city.trim();
      }
      /*
      if (data.zipcode) {
        mappedInstitute.zip_code = data.zipcode.trim();
      }*/
      if (data.country_code) {
        mappedInstitute.country_code = data.country_code.trim().toUpperCase();
      }
      else {
        mappedInstitute.country_code = "DE";
      }
      this.SET_SELECTEDINSTITUTE({'selectedInstitute': mappedInstitute});
    },
    authorCreated(author_id) {
      /*
      this.importAuthor = false;
      this.importInstitute = false;
      this.$store.dispatch('GET_AUTHORS', this.$route.params.id)
      this.cancel();
      */
      this.selectedInstitute.author_id = author_id;
      this.SET_SELECTEDINSTITUTE({'selectedInstitute': this.selectedInstitute});
      this.$store.dispatch('GET_ONE_AUTHOR', author_id);
      this.importAuthor = false;
      this.importInstitute = true;


    },
    instituteCreated() {
      console.log('inst created')
      this.$store.dispatch('GET_AUTHORS', this.$route.params.id)
      this.cancel();
    },
    cancel() {
      this.importInstitute = false;
      this.$set(this.mode, 'import', false);
      $('#authorImportModal').modal('hide');
    },
    manually() {
      this.cancel();
      this.$emit('enterManually');
    }
  }
}
</script>

<style scoped>

</style>
